/*=================================================
    summary: 老師 看 / 改 學生考卷 選擇題 Choice Question 單元
             選擇題型
             練習 聽一聽            LUSeqNo: 13       
             複習 聽力理解          LUSeqNo: 20
             練習 讀一讀            LUSeqNo: 15
             複習 閱讀練習          LUSeqNo: 21
             Practice Listening
             Review Listening
             Practice ReadingComprehension
             Review Reading

    remarks: 000 Tim 2021/12/01 Create
             001 Tim 2021/12/23 加入 PaintedMe流程
=================================================*/
import React, { useState, useEffect, useRef } from 'react'
import cssAssignmentChoiceQuestion from './AssignmentChoiceQuestion.module.scss'
import '../../../../Utils/OldContentInlinClass.css'
import {GlobalLibs} from 'bc-react-package'

import parse from 'html-react-parser'

// #region Constant
const IMAGE_DISPLAY_WIDTH = 700
// #endregion Constant

// #region State Member Variables
let marrStateAudioStatus = []
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let marrDisplayQuestion = []
let mstrImagePrefix = ""
let mintPlayAudioIndex = -1
let mintAccountRole = 0

let marrContentData = []
let mintSQIndex4PreloadThumbnailImage = 0
let mintImgIndex4PreloadThumbnailImage = 0
let mintSQIndex4PreloadOriginalImage = 0
let mintImgIndex4PreloadOriginalImage = 0
let mintSQIndex4OriginalAnsImg = 0
let mintCQIndex4OriginalAnsImg = 0
let mintImgIndex4OriginalAnsImg = 0
// #endregion Member Variables

// #region Enumeration
const AnswerTypeEnum = {
    "Text": 1,
    "Image": 2
}
// #endregion Enumeration


const COMP_NAME = "AssignmentChoiceQuestion"

function AssignmentChoiceQuestion(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)
    const [audioStatusArray, setAudioStatusArray] = useState([])
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true
        mintAccountRole = window.Globals.GetClassAccountRole(window.gSession.Acc.CurrentClassIndex)
        mstrImagePrefix = window.Globals.GetResourcePrefix(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Image)

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    
    // Update audioStatusArray
    useEffect(() => {
        marrStateAudioStatus = audioStatusArray

        console.log(COMP_NAME + ".Update audioStatusArray: marrStateAudioStatus: ", marrStateAudioStatus)
    }, [audioStatusArray])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")

            window.AudioLibs.RemoveEventHandlerRef(window.AudioLibs.RegisterEventTypeEnum.AudioEnded)
            window.AudioLibs.StopAudio()
            mintPlayAudioIndex = -1
            mblnInitialized = false

            setAudioStatusArray([])
            setUpdateDataTime(0)
        }
    }, [])


    // #region Painted Me
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        window.AudioLibs.RegisterEventHandlerRef(PlayAudioEndHandler, window.AudioLibs.RegisterEventTypeEnum.AudioEnded)

        InitContentDataProcessBegin()
    } // end of PaintedMe
    // #endregion Painted Me

    // #region OnTapHandler
    /*===========================================
    summary: 點選 聲音播放
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function AudioPlayOnTapHandler(AudioFN, QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioPlayOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        if (arrAudioStatus[QuestionIndex] === window.gAudioStatusEnum.Paused)
        {
            window.AudioLibs.Play()
        }
        else
        {
            let strAudioUrl = window.Globals.GetResourceUrl(props.BookCatID, props.LessonID, window.gResourceTypeEnum.Audio, AudioFN)
            window.AudioLibs.PlayAudio(strAudioUrl)
        }

        if (mintPlayAudioIndex !== QuestionIndex)
        {
            arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        }

        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Playing
        mintPlayAudioIndex = QuestionIndex
        setAudioStatusArray(arrAudioStatus)
    } // end of AudioPlayOnTapHandler

    /*===========================================
    summary: 點選 聲音停止
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioStopOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1

        window.AudioLibs.StopAudio()
    } // end of AudioStopOnTapHandler

    /*===========================================
    summary: 點選 聲音暫停
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function AudioPauseOnTapHandler(QuestionIndex, StateAudioStatusArray)
    {
        console.log(COMP_NAME + ".AudioPauseOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let arrAudioStatus = JSON.parse(JSON.stringify(StateAudioStatusArray))
        arrAudioStatus[QuestionIndex] = window.gAudioStatusEnum.Paused
        setAudioStatusArray(arrAudioStatus)     

        window.AudioLibs.PauseAudio()
    } // end of AudioPauseOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: 播放聲音 結束事件
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function PlayAudioEndHandler()
    {
        console.log(COMP_NAME + ".PlayAudioEndHandler")

        let arrAudioStatus = JSON.parse(JSON.stringify(marrStateAudioStatus))
        arrAudioStatus[mintPlayAudioIndex] = window.gAudioStatusEnum.Stop
        setAudioStatusArray(arrAudioStatus) 

        mintPlayAudioIndex = -1
    } // end of PlayAudioEndHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert
    /*===========================================
    summary: 開啟 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log("OpenLoadingMask: ", LoadingMsg)

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 LoadingMask
    remarks: 000 Tim 2022/01/05 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        // console.log(COMP_NAME + ".CloseLoadingMask: ")     // Richard 習慣這樣找 Function  Tim22.01.03
        console.log(COMP_NAME + ".CloseLoadingMask BEGIN")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask
    // #region LoadingMask and Alert

    // #region Other Functions
    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessBegin()
    {
        console.log(COMP_NAME + ".InitContentDataProcessBegin: ")

        OpenLoadingMask(window.gAppUI.MSG_LoadMask_LoadImage)

        marrContentData = []

        let arrKeywordList = []
        let objContent = null

        // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小，且顯示題目縮圖
        // Step 3. Preload 所有原圖 每讀取完一張原圖 就顯示
        // Step 4. 讀取 答案原圖 每讀取完一張原圖 就顯示

        props.LearningUnitData.SuperQuestion.forEach((SuperQuestion) => {
            // Step 1. 讀取 HtmlContent, 取得 裡面的所有大圖路徑及縮圖路徑放入ImageList
            arrKeywordList = (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major) ? SuperQuestion.ContentHTML.MajorLangKeyword : SuperQuestion.ContentHTML.MinorLangKeyword
            objContent = window.Globals.CreateContentText(SuperQuestion.ContentHTML.TextWithHeight, arrKeywordList, mstrImagePrefix)

            marrContentData.push(objContent)
        })

        console.log("marrContentData: ", marrContentData)

        // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
        PreloadThumbnailImageProcessBegin()
    } // end of InitContentDataProcessBegin

    /*===========================================
    summary: 初始化 題目內容 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 調整 先讀縮圖 再讀原圖
    ===========================================*/
    function InitContentDataProcessEnd()
    {
        console.log(COMP_NAME + ".InitContentDataProcessEnd: ")

        CloseLoadingMask()

        marrDisplayQuestion = FormatCQQuestionData(props.LearningUnitData, props.TeacherAssignmentData)
        InitAudioStatusArray(marrDisplayQuestion)

        // 先顯示出來
        setUpdateDataTime(new Date().getTime())

        // Step 3. 讀取 每一張原圖 每讀取完一張就顯示
        PreloadOriginalImageProcessBegin()
    } // end of InitContentDataProcessEnd

    // #region PreloadImage
    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessBegin: ")

        mintSQIndex4PreloadThumbnailImage = 0
        mintImgIndex4PreloadThumbnailImage = 0

        if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
        {
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else
        {
            GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
    } // end of PreloadThumbnailImageProcessBegin

    /*===========================================
    summary: 預讀 縮圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function PreloadThumbnailImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadThumbnailImageProcessEnd: ")

        // Step 4. 將 圖片高度 正確計算之後，回寫進去 ContentHtml，再 顯示畫面
        marrContentData.forEach((ContentData) => {
            // Step 2. Preload 所有縮圖後 取得其高寬比例後 設定style 讓縮圖可顯示合適的大小
            // 將ContentText內 所有的原圖URL 改成 縮圖URL 並且 在每一張圖上設定style指定高寬
            ContentData.ContentText = window.Globals.ChangeAllImageToThumbnailImageAndSpecifyWithHeight(ContentData.ContentText, ContentData.ImageList)

            console.log("ContentData: ", ContentData)
        }) // end of forEach marrContentData

        console.log("PreloadImageProcessEnd END marrContentData: ", marrContentData)

        InitContentDataProcessEnd()
    } // end of PreloadThumbnailImageProcessEnd

    /*===========================================
    summary: 讀取 縮圖 題目圖片
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function LoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadThumbnailImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            ThumbnailImageLoadedHandler(SQIndex, ImgIndex, this.width, this.height)
        }; // end of image onload
        // objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].Url
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].ThumbnailImageUrl
    } // end of LoadThumbnailImage

    /*===========================================
    summary: 讀取 縮圖 題目圖片完成 事件
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function ThumbnailImageLoadedHandler(SQIndex, ImgIndex, Width, Height)
    {
        console.log(COMP_NAME + ".ThumbnailImageLoadedHandler: ", SQIndex, ImgIndex, Width, Height)

        // 避免 ThumbnailImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            marrContentData[SQIndex].ImageList[ImgIndex].Width = Width
            marrContentData[SQIndex].ImageList[ImgIndex].Height = Height

            let intDisplayWidth = IMAGE_DISPLAY_WIDTH

            marrContentData[SQIndex].ImageList[ImgIndex].DisplayWidth = intDisplayWidth
            marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight = parseInt(intDisplayWidth / (Width / Height))

            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler END DisplayHeight: ", parseInt(marrContentData[SQIndex].ImageList[ImgIndex].DisplayHeight))

            GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".ThumbnailImageLoadedHandler ContentData null")
        }
    } // end of ThumbnailImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 縮圖
    remarks: 000 Tim 2022/01/13 Create
             001 Tim 2022/08/25 改成先讀縮圖
    ===========================================*/
    function GotoNextLoadThumbnailImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadThumbnailImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadThumbnailImage++
            LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadThumbnailImage++
            mintImgIndex4PreloadThumbnailImage = 0

            if (marrContentData[mintSQIndex4PreloadThumbnailImage].ImageList.length > 0)
            {
                LoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
            else
            {
                GotoNextLoadThumbnailImage(mintSQIndex4PreloadThumbnailImage, mintImgIndex4PreloadThumbnailImage)
            }
        }
        else
        {
            PreloadThumbnailImageProcessEnd()
        }
    } // end of GotoNextLoadThumbnailImage

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessBegin: ")

        mintSQIndex4PreloadOriginalImage = 0
        mintImgIndex4PreloadOriginalImage = 0

        if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
        {
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else
        {
            GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
    } // end of PreloadOriginalImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 題目圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalImageProcessEnd: ")

        // Step 4. 讀取 答案原圖 每讀取完一張原圖 就顯示
        PreloadOriginalAnswerImageProcessBegin()
    } // end of PreloadOriginalImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 題目圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalImage: ", SQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalImageLoadedHandler(SQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalImage

    /*===========================================
    summary: 讀取 原圖 題目圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalImageLoadedHandler(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalImageLoadedHandler: ", SQIndex, ImgIndex)
        
        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrContentData.length > 0) &&
            (typeof(marrContentData[SQIndex]) !== "undefined") &&
            (marrContentData[SQIndex] !== null) &&
            (typeof(marrContentData[SQIndex].ImageList) !== "undefined") &&
            (marrContentData[SQIndex].ImageList !== null) &&
            (typeof(marrContentData[SQIndex].ImageList[ImgIndex]) !== "undefined") &&
            (marrContentData[SQIndex].ImageList[ImgIndex] !== null)
            )
        {
            let strOriginalImageUrl = marrContentData[SQIndex].ImageList[ImgIndex].OriginalImageUrl
            console.log("strOriginalImageUrl: ", strOriginalImageUrl)
            let strContentText = marrContentData[SQIndex].ContentText
            console.log("strContentText: ", strContentText)
            marrContentData[SQIndex].ContentText = window.Globals.ChangeThumbnailImageUrlToOriginalImageUrl(strContentText, ImgIndex, strOriginalImageUrl)
            marrDisplayQuestion[SQIndex].ContentText = marrContentData[SQIndex].ContentText
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalImage(SQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalImageLoadedHandler ContentData null")
        }
    } // end of OriginalImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalImage(SQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalImage: ", SQIndex, ImgIndex)

        if (
            (marrContentData[SQIndex].ImageList.length > 0) &&
            (ImgIndex < (marrContentData[SQIndex].ImageList.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4PreloadOriginalImage++
            LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
        }
        else if (SQIndex < (marrContentData.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4PreloadOriginalImage++
            mintImgIndex4PreloadOriginalImage = 0

            if (marrContentData[mintSQIndex4PreloadOriginalImage].ImageList.length > 0)
            {
                LoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
            else
            {
                GotoNextLoadOriginalImage(mintSQIndex4PreloadOriginalImage, mintImgIndex4PreloadOriginalImage)
            }
        }
        else
        {
            PreloadOriginalImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalImage

    /*===========================================
    summary: 預讀 原圖 答案圖片 流程 開始
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalAnswerImageProcessBegin()
    {
        console.log(COMP_NAME + ".PreloadOriginalAnswerImageProcessBegin: ")

        mintSQIndex4OriginalAnsImg = 0
        mintCQIndex4OriginalAnsImg = 0
        mintImgIndex4OriginalAnsImg = 0
        
        if (
            (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].AnswerType) === AnswerTypeEnum.Image) &&
            (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].Answer.length > 0)
            )
        {
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else
        {
            GotoNextLoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
    } // end of PreloadOriginalAnswerImageProcessBegin

    /*===========================================
    summary: 預讀 原圖 答案圖片 流程 結束
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function PreloadOriginalAnswerImageProcessEnd()
    {
        console.log(COMP_NAME + ".PreloadOriginalAnswerImageProcessEnd: ")
    } // end of PreloadOriginalAnswerImageProcessEnd

    /*===========================================
    summary: 讀取 原圖 答案圖片
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function LoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".LoadOriginalAnswerImage: ", SQIndex, CQIndex, ImgIndex)

        let objImage = new Image()
        objImage.onload = function ()
        {
            OriginalAnswerImageLoadedHandler(SQIndex, CQIndex, ImgIndex)
        }; // end of image onload
        objImage.src = marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].OriginalImageUrl
    } // end of LoadOriginalAnswerImage

    /*===========================================
    summary: 讀取 原圖 答案圖片完成 事件
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function OriginalAnswerImageLoadedHandler(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".OriginalAnswerImageLoadedHandler: ", SQIndex, CQIndex, ImgIndex)
        
        // 避免 OriginalImageLoadedHandler 觸發的時候 已經換到其他頁 導致讀不到資料跳錯
        if(
            (marrDisplayQuestion.length > 0) &&
            (typeof(marrDisplayQuestion[SQIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex] !== null) &&
            (typeof(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex] !== null) &&
            (typeof(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex]) !== "undefined") &&
            (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex] !== null)
            )
        {
            marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].DisplayUrl = marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer[ImgIndex].OriginalImageUrl
            
            // 原圖每Load完成一張就顯示
            setUpdateDataTime(new Date().getTime()) 

            GotoNextLoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
        }
        else
        {
            console.log(COMP_NAME + ".OriginalAnswerImageLoadedHandler ContentData null")
        }
    } // end of OriginalAnswerImageLoadedHandler

    /*===========================================
    summary: 讀取下一張 答案原圖
    remarks: 000 Tim 2022/08/25 Create
    ===========================================*/
    function GotoNextLoadOriginalAnswerImage(SQIndex, CQIndex, ImgIndex)
    {
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage: ", SQIndex, CQIndex, ImgIndex)

        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage DQ: ", marrDisplayQuestion[SQIndex])
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage ChoiceQ.length: ", marrDisplayQuestion[SQIndex].ChoiceQ.length)
        console.log(COMP_NAME + ".GotoNextLoadOriginalAnswerImage Answer.length: ", marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer.length)

        if (
            (marrDisplayQuestion[SQIndex].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
            (ImgIndex < (marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].Answer.length - 1))
            )
        {
            // ImageList 還沒讀完
            mintImgIndex4OriginalAnsImg++
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else if (
            (marrDisplayQuestion[SQIndex].ChoiceQ.length > 0) &&
            (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
            (CQIndex < (marrDisplayQuestion[SQIndex].ChoiceQ.length - 1))
            )
        {
            mintCQIndex4OriginalAnsImg++
            mintImgIndex4OriginalAnsImg = 0
            LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
        }
        else if (SQIndex < (marrDisplayQuestion.length - 1))
        {
            // 這SuperQuestion 還沒讀完
            mintSQIndex4OriginalAnsImg++
            mintCQIndex4OriginalAnsImg = 0
            mintImgIndex4OriginalAnsImg = 0

            if (
                (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ.length > 0) &&
                (parseInt(marrDisplayQuestion[SQIndex].ChoiceQ[CQIndex].AnswerType) === AnswerTypeEnum.Image) &&
                (marrDisplayQuestion[mintSQIndex4OriginalAnsImg].ChoiceQ[mintCQIndex4OriginalAnsImg].Answer.length > 0)
                )
            {
                LoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
            }
            else
            {
                GotoNextLoadOriginalAnswerImage(mintSQIndex4OriginalAnsImg, mintCQIndex4OriginalAnsImg, mintImgIndex4OriginalAnsImg)
            }
        }
        else
        {
            PreloadOriginalAnswerImageProcessEnd()
        }
    } // end of GotoNextLoadOriginalAnswerImage
    // #endregion PreloadImage

    /*===========================================
    summary: 初始化 選擇題 答案資料
    remarks: 000 Tim 2021/12/01 Create
    ===========================================*/
    function FormatCQQuestionData(LearningUnit, TeacherAssignment)
    {
        console.log(COMP_NAME + ".FormatCQQuestionData: ", LearningUnit, TeacherAssignment)

        let arrSuperQuestion = LearningUnit.SuperQuestion
        let arrDisplayQuestion = []
        let objDisplayQuestion = null
        let objChoiceQ = null

        let intSQIndex = 0
        let intSQCount = arrSuperQuestion.length
        let intCQIndex = 0
        let intCQCount = 0
        let arrAnswer = []
        let objAnswer = null
        let intAIndex = 0
        let intACount = 0
        let intNAIndex = 0

        let arrChoiceQ = []
        let arrCAnswer = []
        let objCAnswer = null

        let intDefQShow = 0
        let intDefAShow = 0

        let objContent = null

        let strOriginalImageUrl = ""
        let strThumbnailImageUrl = ""

        if (
            (typeof(TeacherAssignment) !== 'undefined') &&
            (TeacherAssignment !== null) &&
            (typeof(TeacherAssignment.NewAssignList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList !== null) &&
            (TeacherAssignment.NewAssignList.length > 0) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex]) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex] !== null) &&
            (typeof(TeacherAssignment.NewAssignList[intNAIndex].AnswerList) !== 'undefined') &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList !== null) &&
            (TeacherAssignment.NewAssignList[intNAIndex].AnswerList.length > 0)
            )
        {
            arrAnswer = TeacherAssignment.NewAssignList[intNAIndex].AnswerList
        }

        for (intSQIndex = 0; intSQIndex < intSQCount; intSQIndex++)
        {
            // 處理 顯示的 Content
            objContent = marrContentData[intSQIndex]
            console.log(COMP_NAME + ".FormatCQQuestionData: objContent: ", objContent)

            objDisplayQuestion = {
                "SQSeqNo": arrSuperQuestion[intSQIndex].SQSeqNo,
                "ContentText": objContent.ContentText,
                "AudioFN": objContent.AudioFN,
                "IsAudio": objContent.IsAudio,
                "ChoiceQ": []
            }

            intCQIndex = 0
            intCQCount = arrSuperQuestion[intSQIndex].ChoiceQ.length
            arrChoiceQ = arrSuperQuestion[intSQIndex].ChoiceQ

            for (intCQIndex = 0; intCQIndex < intCQCount; intCQIndex++)
            {
                objChoiceQ = {
                    "CQSeqNo": arrChoiceQ[intCQIndex].CQSeqNo,
                    "QuestionText": "",
                    "AnswerType": arrChoiceQ[intCQIndex].AnswerType,
                    "AnswerPos": arrChoiceQ[intCQIndex].AnswerPos,
                    "Answer": [],
                    "CQAnswerPos": -1
                }

                let intSQSeqNo = parseInt(arrSuperQuestion[intSQIndex].SQSeqNo)
                let intCQSeqNo = parseInt(arrChoiceQ[intCQIndex].CQSeqNo)
                intDefQShow = arrChoiceQ[intCQIndex].DefQShow
                intDefAShow = arrChoiceQ[intCQIndex].DefAShow

                // 有 DefQShowNew 使用這個值 沒有的話，沿用 DefQShow，舊程式沒註解，不知道原因     Tim16.11.28
                if (
                    (typeof(arrChoiceQ[intCQIndex].DefQShowNew) !== 'undefined') &&
                    (arrChoiceQ[intCQIndex].DefQShowNew !== null) &&
                    (arrChoiceQ[intCQIndex].DefQShowNew !== '') &&
                    (!isNaN(parseInt(arrChoiceQ[intCQIndex].DefQShowNew)))
                    )
                {
                    intDefQShow = parseInt(arrChoiceQ[intCQIndex].DefQShowNew)
                }

                // 找出 顯示 題目文字
                if (parseInt(intDefQShow) === 1)
                {
                    objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].Q
                }
                else
                {
                    if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                    {
                        objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].MajorQ
                    }
                    else
                    {
                        objChoiceQ.QuestionText = arrChoiceQ[intCQIndex].MinorQ
                    }
                }

                // 找出 使用者 選擇的答案
                objAnswer = arrAnswer.find(AnswerData => 
                    (
                        (parseInt(AnswerData.SQSeqNo) === intSQSeqNo) &&
                        (parseInt(AnswerData.CQSeqNo) === intCQSeqNo)
                    )
                )

                if (
                    (typeof(objAnswer) !== 'undefined') &&
                    (objAnswer !== null)
                    )
                {
                    objChoiceQ.CQAnswerPos = parseInt(objAnswer.CQAnswerPos)
                }

                // 塞入 選擇題 答案陣列
                intAIndex = 0
                intACount = arrChoiceQ[intCQIndex].Answer.length
                arrCAnswer = []
                for (intAIndex = 0; intAIndex < intACount; intAIndex++)
                {
                    if (parseInt(objChoiceQ.AnswerType) === AnswerTypeEnum.Text)
                    {
                        objCAnswer = {
                            "AnswerText": ""
                        }
                        // 找出 顯示 答案文字
                        if (parseInt(intDefAShow) === 1)
                        {
                            objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].A
                        }
                        else if (parseInt(intDefAShow) === 2)
                        {
                            if (window.gSession.Acc.Preferences.Lang === window.gLangTypeEnum.Major)
                            {
                                objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].MajorA
                            }
                            else
                            {
                                objCAnswer.AnswerText = arrChoiceQ[intCQIndex].Answer[intAIndex].MinorA
                            }
                        }
                    }
                    else
                    {
                        strOriginalImageUrl = mstrImagePrefix + arrChoiceQ[intCQIndex].Answer[intAIndex].ImgAFN
                        strThumbnailImageUrl = window.Globals.GetImageThumbnailUrl(strOriginalImageUrl)

                        objCAnswer = {
                            "ImgAFN": arrChoiceQ[intCQIndex].Answer[intAIndex].ImgAFN,
                            "DisplayUrl": strThumbnailImageUrl,
                            "OriginalImageUrl": strOriginalImageUrl,
                            "ThumbnailImageUrl": strThumbnailImageUrl
                        }
                    }
                    arrCAnswer.push(objCAnswer)
                } // end of for (intAIndex = 0;
                objChoiceQ.Answer = arrCAnswer

                objDisplayQuestion.ChoiceQ.push(objChoiceQ)
            } // end of for (intCQIndex = 0;
            arrDisplayQuestion.push(objDisplayQuestion)
        } // end of for (intSQIndex = 0;

        console.log(COMP_NAME + ".FormatCQQuestionData arrDisplayQuestion: ", arrDisplayQuestion)

        return arrDisplayQuestion
    } // end of FormatCQQuestionData

    /*===========================================
    summary: 初始化 音檔狀態
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function InitAudioStatusArray(DisplayQuestion)
    {
        let arrAudioStatus = []
        DisplayQuestion.forEach(() => {
            arrAudioStatus.push(window.gAudioStatusEnum.Stop)
        })

        console.log(COMP_NAME + ".InitAudioStatusArray arrAudioStatus: ", arrAudioStatus)

        setAudioStatusArray(arrAudioStatus)
    } // end of InitAudioStatusArray
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 答案選項 圖片外框 Cls
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function GetAnswerImageCls(AnswerIndex, AnswerPos, CQAnswerPos)
    {
        let objCls = cssAssignmentChoiceQuestion.divAnswerImage

        if (CQAnswerPos === (AnswerIndex + 1))
        {
            if (AnswerPos === CQAnswerPos)
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageSuccess
            }
            else
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageWrong
            }
        }

        if (            
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&    // Student
                (
                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                    
                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 身份是學生，且 老師設定 不顯示正確答案
        }
        else
        {
            // 其他都要顯示正確答案
            if (AnswerPos === (AnswerIndex + 1))
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageSuccess
            }
        }

        return objCls
    } // end of GetAnswerImageCls

    /*===========================================
    summary: 取得 圖片題 答案選項 Icon Cls
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function GetAnswerImageIconCls(AnswerIndex, AnswerPos, CQAnswerPos)
    {
        let objCls = cssAssignmentChoiceQuestion.divAnswerImageIcon

        if (CQAnswerPos === (AnswerIndex + 1))
        {
            if (AnswerPos === CQAnswerPos)
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageIconSuccess
            }
            else
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageIconWrong
            }
        }

        if (            
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&    // Student
                (
                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                    
                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 身份是學生，且 老師設定 不顯示正確答案
        }
        else
        {
            // 其他都要顯示正確答案
            if (AnswerPos === (AnswerIndex + 1))
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerImageIconSuccess
            }
        }

        return objCls
    } // end of GetAnswerImageIconCls

    /*===========================================
    summary: 取得 文字題 答案選項 圖片外框 Cls
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function GetTextAnswerTextAreaCls(AnswerIndex, AnswerPos, CQAnswerPos)
    {
        let objCls = cssAssignmentChoiceQuestion.divTextAnswerTextArea

        if (CQAnswerPos === (AnswerIndex + 1))
        {
            if (AnswerPos === CQAnswerPos)
            {
                objCls = cssAssignmentChoiceQuestion.divTextAnswerTextAreaSuccess
            }
            else
            {
                objCls = cssAssignmentChoiceQuestion.divTextAnswerTextAreaWrong
            }
        }

        if (            
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&    // Student
                (
                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                    
                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 身份是學生，且 老師設定 不顯示正確答案
        }
        else
        {
            // 其他都要顯示正確答案
            if (AnswerPos === (AnswerIndex + 1))
            {
                objCls = cssAssignmentChoiceQuestion.divTextAnswerTextAreaSuccess
            }
        }

        return objCls
    } // end of GetAnswerImageCls

    /*===========================================
    summary: 取得 文字題 答案選項 Icon Cls
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function GetAnswerTextIconCls(AnswerIndex, AnswerPos, CQAnswerPos)
    {
        let objCls = cssAssignmentChoiceQuestion.divAnswerTextIcon

        if (CQAnswerPos === (AnswerIndex + 1))
        {
            if (AnswerPos === CQAnswerPos)
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerTextIconSuccess
            }
            else
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerTextIconWrong
            }
        }

        if (            
            (mintAccountRole === window.gConst.CLASS_ACCOUNT_ROLE_STUDENT) &&    // Student
                (
                    (typeof(window.gSession.Acc.CurrentClassIndex) !== 'undefined') &&
                    (window.gSession.Acc.CurrentClassIndex !== null) &&
                    (parseInt(window.gSession.Acc.CurrentClassIndex) >= 0) &&

                    (typeof(window.gSession.Acc.Class) !== 'undefined') &&
                    (window.gSession.Acc.Class !== null) &&
                    (window.gSession.Acc.Class.length !== null) &&

                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex]) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex] !== null) &&
                    
                    (typeof(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) !== 'undefined') &&
                    (window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow !== null) &&
                    (parseInt(window.gSession.Acc.Class[window.gSession.Acc.CurrentClassIndex].IsDCPAnswerShow) === 0)
                )
            )
        {
            // 身份是學生，且 老師設定 不顯示正確答案
        }
        else
        {
            // 其他都要顯示正確答案
            if (AnswerPos === (AnswerIndex + 1))
            {
                objCls = cssAssignmentChoiceQuestion.divAnswerTextIconSuccess
            }
        }

        return objCls
    } // end of GetAnswerTextIconCls
    // #endregion Get ClassName

    // #region Render元件
    /*===========================================
    summary: ChoiceQNo 顯示Component  
    remarks: 000 Tim 2021/12/03 Create
             001 Tim 2022/08/25 改圖片 直接用 DisplayUrl顯示
    ===========================================*/
    function ComponentAnswerImage( {AnswerData, AnswerIndex, AnswerPos, CQAnswerPos} )
    {   
        // let strAnswerUrl = mstrImagePrefix + AnswerData.ImgAFN
        let objStyle = {
            backgroundImage: 'url(' + AnswerData.DisplayUrl + ')'
        }

        return(
            <div className={GetAnswerImageCls(AnswerIndex, AnswerPos, CQAnswerPos)} style={objStyle}/>
        )
    } // end of ComponentAnswerImage
    
    /*===========================================
    summary: ChoiceQNo 顯示Component  
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function ComponentAnswerNo( {AnswerIndex} )
    {   
        // AnsNo
        let strAnsNo = ""
        switch (AnswerIndex)
        {
            case 0:
                strAnsNo = 'a.';
                break
            case 1:
                strAnsNo = 'b.';
                break
            case 2:
                strAnsNo = 'c.';
                break
            case 3:
                strAnsNo = 'd.';
                break
            default:
                break
        } 

        return(
            <div className={cssAssignmentChoiceQuestion.divAnswerNo}>
                {strAnsNo}
            </div>
        )
    } // end of ComponentAnswerNo

    /*===========================================
    summary: ChoiceQNo 顯示Component  
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function ComponentChoiceQNo( {ChoiceQIndex} )
    {   
        let strNo = (ChoiceQIndex + 1).toString() + "."
        return(
            <div className={cssAssignmentChoiceQuestion.divChoiceQNo}>
                {strNo}
            </div>
        )
    } // end of ComponentChoiceQNo
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderImageAnswerUnitWrapper(AnswerData, AnswerIndex, AnswerPos, CQAnswerPos)
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divImageAnswerUnitMain}>
                <ComponentAnswerNo AnswerIndex={AnswerIndex}/>

                <ComponentAnswerImage AnswerData={AnswerData} AnswerIndex={AnswerIndex} AnswerPos={AnswerPos} CQAnswerPos={CQAnswerPos}/>

                <div className={GetAnswerImageIconCls(AnswerIndex, AnswerPos, CQAnswerPos)}/>
            </div>
        )
    } // end of RenderImageAnswerUnitWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderQuestionAnswerImageWrapper(ChoiceQData)
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divImageAnswerMain}>
                {ChoiceQData.Answer.map((AnswerData, AnswerIndex) =>
                    <div key={AnswerIndex} className={cssAssignmentChoiceQuestion.divImageAnswerUnit}>
                        {RenderImageAnswerUnitWrapper(AnswerData, AnswerIndex, parseInt(ChoiceQData.AnswerPos), parseInt(ChoiceQData.CQAnswerPos))}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAnswerImageWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderTextAnswerUnitWrapper(AnswerData, AnswerIndex, AnswerPos, CQAnswerPos)
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divTextAnswerUnitMain}>
                <div className={GetTextAnswerTextAreaCls(AnswerIndex, AnswerPos, CQAnswerPos)}>
                    <ComponentAnswerNo AnswerIndex={AnswerIndex}/>
                    <div className={cssAssignmentChoiceQuestion.divAnswerText}>
                        {AnswerData.AnswerText}
                    </div>
                </div>
                
                <div className={GetAnswerTextIconCls(AnswerIndex, AnswerPos, CQAnswerPos)}/>
            </div>
        )
    } // end of RenderTextAnswerUnitWrapper

    /*===========================================
    summary: Render Question Sub Image Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderQuestionAnswerTextWrapper(ChoiceQData)
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divTextAnswerMain}>
                {ChoiceQData.Answer.map((AnswerData, AnswerIndex) =>
                    <div key={AnswerIndex} className={cssAssignmentChoiceQuestion.divTextAnswerUnit}>
                        {RenderTextAnswerUnitWrapper(AnswerData, AnswerIndex, parseInt(ChoiceQData.AnswerPos), parseInt(ChoiceQData.CQAnswerPos))}
                    </div>
                )}
            </div>
        )
    } // end of RenderQuestionAnswerTextWrapper

    /*===========================================
    summary: Render Question Sub Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderQuestionSubUnitWrapper(ChoiceQData, ChoiceQIndex)
    {
        if (parseInt(ChoiceQData.AnswerType) === AnswerTypeEnum.Text)
        {
            return RenderQuestionAnswerTextWrapper(ChoiceQData)
        }
        else
        {
            return RenderQuestionAnswerImageWrapper(ChoiceQData)
        }
    } // end of RenderQuestionSubUnitWrapper

    /*===========================================
    summary: Render Question Unit 的顯示
    remarks: 000 Tim 2021/12/03 Create
    ===========================================*/
    function RenderQuestionUnitWrapper(ChoiceQData, ChoiceQIndex)
    {
        return (
            <>
                <div className={cssAssignmentChoiceQuestion.divQuestionTextMain}>
                    <ComponentChoiceQNo ChoiceQIndex={ChoiceQIndex}/>

                    <div className={cssAssignmentChoiceQuestion.divQuestionText}>
                        {ChoiceQData.QuestionText}
                    </div>
                </div>

                {RenderQuestionSubUnitWrapper(ChoiceQData, ChoiceQIndex)}
            </>
        )
    } // end of RenderQuestionUnitWrapper

    /*===========================================
    summary: Render Question Audio Tool 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderQuestionAudioToolWrapper(QuestionData, QuestionIndex, StateAudioStatusArray)
    {
        if (
            (typeof (QuestionData.AudioFN) !== 'undefined') &&
            (QuestionData.AudioFN !== null) &&
            (QuestionData.AudioFN !== "")
            )
        {
            let objBlock = ""
            if (StateAudioStatusArray[QuestionIndex] === window.gAudioStatusEnum.Stop)
            {
                // window.gAudioStatusEnum.Stop
                objBlock =  <>
                                <div className={cssAssignmentChoiceQuestion.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssAssignmentChoiceQuestion.btnAudioStopDisabled}/>
                            </>
            }
            else if (StateAudioStatusArray[QuestionIndex] === window.gAudioStatusEnum.Playing)
            {
                // window.gAudioStatusEnum.Playing
                objBlock =  <>
                                <div className={cssAssignmentChoiceQuestion.btnAudioPause} onClick={() => AudioPauseOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssAssignmentChoiceQuestion.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                            </>
            }
            else
            {
                // window.gAudioStatusEnum.Paused
                objBlock =  <>
                                <div className={cssAssignmentChoiceQuestion.btnAudioPlay} onClick={() => AudioPlayOnTapHandler(QuestionData.AudioFN, QuestionIndex, StateAudioStatusArray)}/>
                                <div className={cssAssignmentChoiceQuestion.btnAudioStop} onClick={() => AudioStopOnTapHandler(QuestionIndex, StateAudioStatusArray)}/>
                            </>
            }

            return (
                <div className={cssAssignmentChoiceQuestion.divQuestionAudioTool}>
                    {objBlock}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderQuestionAudioToolWrapper

    /*===========================================
    summary: Render Question Title Area 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divQuestionTitleArea}>
                <div className={cssAssignmentChoiceQuestion.divContentText}>
                    {parse(QuestionData.ContentText)}
                </div>

                {RenderQuestionAudioToolWrapper(QuestionData, QuestionIndex, audioStatusArray)}
            </div>
        )
    } // end of RenderQuestionTitleAreaWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderContentWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <div className={cssAssignmentChoiceQuestion.divContent}>
                    {marrDisplayQuestion.map((QuestionData, QuestionIndex) =>
                        <div key={QuestionIndex} className={cssAssignmentChoiceQuestion.divQuestionMain}>
                            {RenderQuestionTitleAreaWrapper(QuestionData, QuestionIndex)}

                            {QuestionData.ChoiceQ.map((ChoiceQData, ChoiceQIndex) =>
                                <div key={ChoiceQIndex}  className={cssAssignmentChoiceQuestion.divQuestionUnitArea}>
                                    {RenderQuestionUnitWrapper(ChoiceQData, ChoiceQIndex)}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/12/02 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssAssignmentChoiceQuestion.divMain}>
                {RenderContentWrapper(updateDataTime)}
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default AssignmentChoiceQuestion